import { Address } from './address'
import { Location } from './location'
import { UserProfile, UserTypes } from './user-profile'

type LookingForItem =
  | 'liability'
  | 'startup'
  | 'short_consultation'
  | 'non_binding_comparison'
  | 'looking_around'

type CustomerStatus = 'prospect' | 'won' | 'lost' | 'churned'

export interface Company {
  accountManagerId: string | null
  addressId: number
  address: Address
  bannerUrl: string | null
  businessType: string | null
  companyId: string
  companyWonAt: string | null
  createdAt: Date
  createdBy: string
  customerStatus: CustomerStatus
  damageCountLi: number | null
  foundedDate: Date | null
  isHeadquarters: boolean
  isTest: boolean
  lastDamageDateLi: Date | null
  lastDamageValueLi: number | null
  locations: Location[]
  logoUrl: string | null
  lookingFor: LookingForItem[]
  name: string
  partnerSource: string | null
  poaSigned: boolean
  poaResignReason: PoaResignReason | null
  updatedAt: Date
  users: (UserProfile & { userTypes: UserTypes })[]
}

export interface UserCompany {
  companyId: string
  name: string
  poaSigned: boolean
  userType: UserTypes
}

export enum PoaResignReason {
  ADDRESS_CHANGED = 'company_address_changed',
  NAME_CHANGED = 'company_name_changed',
  MD_CHANGED = 'company_md_changed',
  MULTIPLE_CHANGED = 'company_multiple_fields_changed',
}
